module.exports = __webpack_public_path__ + "img/praise-icon.b85f28f9.png";